class StockConfigurationGlobalActionsViewController extends MUIViewController
{  
    private backButton:MUIButton = null;
    private nextButton:MUIButton = null;
    private tableView:MUITableView = null;

    public delegate = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.backButton = MUIOutlet(this, "back-btn", "MUIButton");
        this.backButton.setAction(this, function (){            
            this.navigationController.popViewController(true);
        });
        
        this.nextButton = MUIOutlet(this, "next-btn", "MUIButton");
        this.nextButton.setAction(this, function (){            
            
        });

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
        this.tableView.delegate = this;
    }

    viewWillAppear(){
        super.viewWillAppear();

        this.updateUI();
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;

        // this.fetchedResultsController = null;
        this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView){
        return 1;
    }

    numberOfRowsInSection(tableView:UITableView, section:number){
        return 3;
    }
    
    private stockOptionsTitle = [MIOLocalizeString("PRODUCT_NO_ELABORATE", "PRODUCT NO ELABORATE"),
                            MIOLocalizeString("PRODUCT_ELABORATE_BEFORE_SELL", "PRODUCT ELABORATE BEFORE SELL"),
                            MIOLocalizeString("PRODUCT_ELABORATE_AT_SELL", "PRODUCT ELABORATE AT SELL")];
    private stockOptions = [MIOLocalizeString("PRODUCT_NO_ELABORATE_DESCRIPTION", "PRODUCT NO ELABORATE DESCRIPTION"),
                            MIOLocalizeString("PRODUCT_ELABORATE_BEFORE_SELL_DESCRIPTION", "PRODUCT ELABORATE BEFORE SELL DESCRIPTION"),
                            MIOLocalizeString("PRODUCT_ELABORATE_AT_SELL_DESCRIPTION", "PRODUCT ELABORATE AT SELL DESCRIPTION")];
    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){        
        let cell = tableView.dequeueReusableCellWithIdentifier("GlobalActionsLabelCell") as GlobalActionsLabelCell;
        cell.title = this.stockOptionsTitle[indexPath.row];
        cell.name = this.stockOptions[indexPath.row];
        // let item = this.fetchedResultsController.objectAtIndexPath(indexPath);                      
        // cell.item = item;
        return cell;
    }   

    didSelectCellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath){ 

        
    }

    private _fetchedResultsController:MIOFetchedResultsController = null;
    set fetchedResultsController(value){
        if (value == null && this._fetchedResultsController != null)
            this._fetchedResultsController.delegate = null;
    
        this._fetchedResultsController = value;
    }
    
    get fetchedResultsController(){
        if (this._fetchedResultsController != null)
            return this._fetchedResultsController;
    
        var ad = MUIWebApplication.sharedInstance().delegate;
        
        let sortDescriptors = [ MIOSortDescriptor.sortDescriptorWithKey('name', true)];
    
        var fetchRequest = DBHelper.listFetchRequestWithEntityName('Stock', sortDescriptors, null);
        var fetchedResultsController = new MIOFetchedResultsController();
        fetchedResultsController.initWithFetchRequest(fetchRequest, ad.managedObjectContext, null);
        fetchedResultsController.delegate = this;
    
        fetchedResultsController.performFetch();

        this._fetchedResultsController = fetchedResultsController;

        return this._fetchedResultsController;
    }

    controllerDidChangeContent(controller:MIOFetchedResultsController){
        this.tableView.reloadData();
    }

}
